import { Calendar as CalendarRc } from '@pba/react-components';
import type { ComponentProps } from 'react';

type EventCalendarProperties = ComponentProps<typeof CalendarRc>;

const Calendar = (props: EventCalendarProperties) => <CalendarRc {...props} />;

export default Calendar;
